/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBarberAppointmentsIdManualAccept200, PostApiBarberAppointmentsIdManualAccept400, PostApiBarberAppointmentsIdManualAccept401, PostApiBarberAppointmentsIdManualAccept403, PostApiBarberAppointmentsIdManualAccept404, PostApiBarberAppointmentsIdManualAccept500, PostApiBarberAppointmentsIdManualAcceptMutationRequest, PostApiBarberAppointmentsIdManualAcceptMutationResponse, PostApiBarberAppointmentsIdManualAcceptPathParams } from "../entities/PostApiBarberAppointmentsIdManualAccept";
import { modelsBarberManualAcceptClientInputSchema } from "./models/barberManualAcceptClientInputSchema";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { z } from "zod/v4";

export const postApiBarberAppointmentsIdManualAcceptPathParamsSchema = z.object({
    "id": z.coerce.number().int().describe("ID записи")
    }) as unknown as z.ZodType<PostApiBarberAppointmentsIdManualAcceptPathParams>

/**
 * @description OK
 */
export const postApiBarberAppointmentsIdManualAccept200Schema = z.object({
    
    }).catchall(z.string()) as unknown as z.ZodType<PostApiBarberAppointmentsIdManualAccept200>

/**
 * @description Bad Request
 */
export const postApiBarberAppointmentsIdManualAccept400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdManualAccept400>

/**
 * @description Unauthorized
 */
export const postApiBarberAppointmentsIdManualAccept401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdManualAccept401>

/**
 * @description Forbidden
 */
export const postApiBarberAppointmentsIdManualAccept403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdManualAccept403>

/**
 * @description Not Found
 */
export const postApiBarberAppointmentsIdManualAccept404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdManualAccept404>

/**
 * @description Internal Server Error
 */
export const postApiBarberAppointmentsIdManualAccept500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdManualAccept500>

/**
 * @description Данные для ручного вызова клиента
 */
export const postApiBarberAppointmentsIdManualAcceptMutationRequestSchema = z.lazy(() => modelsBarberManualAcceptClientInputSchema) as unknown as z.ZodType<PostApiBarberAppointmentsIdManualAcceptMutationRequest>

export const postApiBarberAppointmentsIdManualAcceptMutationResponseSchema = z.lazy(() => postApiBarberAppointmentsIdManualAccept200Schema) as unknown as z.ZodType<PostApiBarberAppointmentsIdManualAcceptMutationResponse>